import { useCallback } from 'react';
import AssignToTeamHeader from '../components/AssignToTeamHeader';
import AssignToUserHeader from '../components/AssignToUserHeader';
import SearchMoreLabel from '../components/SearchMoreLabel';
import TeamOption from '../components/TeamOption';
import UnassignButtonOption from '../components/UnassignButtonOption';
import UserOption from '../components/UserOption';
import { ASSIGN_TO_TEAM_SECTION, ASSIGN_TO_USER_SECTION, SEARCH_MORE_OPTION, UNASSIGN_OPTION } from '../constants/reassignment-dropdown';
import { checkIsTeamAssignee, checkIsUserAssignee } from '../utils/assignee-options';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const renderAssignee = ({
  option,
  currentUserId,
  currentAssigneeId,
  routingSource,
  showCapacityStatus
}) => {
  if (checkIsTeamAssignee(option)) {
    return /*#__PURE__*/_jsx(Flex, {
      paddingInlineStart: "300",
      children: /*#__PURE__*/_jsx(TeamOption, {
        option: option,
        routingSource: routingSource
      })
    });
  }
  if (checkIsUserAssignee(option)) {
    return /*#__PURE__*/_jsx(UserOption, {
      currentAssigneeId: currentAssigneeId,
      currentUserId: currentUserId,
      option: option,
      showCapacityStatus: showCapacityStatus
    });
  }
  return null;
};
export const useAssignmentOptionRenderer = ({
  canRouteToAvailable,
  currentAssigneeId,
  currentUserId,
  handleUnassign,
  routingSource,
  shouldShowTooltip,
  workspaceId,
  showCapacityStatus
}) => useCallback(option => {
  if (!option) {
    return null;
  }

  // we do this because user & team options don't have a section ID but
  // are run through this function
  switch (option.sectionId) {
    case UNASSIGN_OPTION:
      return /*#__PURE__*/_jsx(UnassignButtonOption, {
        currentAssigneeId: currentAssigneeId,
        onClick: handleUnassign
      });
    case ASSIGN_TO_TEAM_SECTION:
      return /*#__PURE__*/_jsx(AssignToTeamHeader, {
        canRouteToAvailable: canRouteToAvailable,
        routingSource: routingSource
      });
    case ASSIGN_TO_USER_SECTION:
      return /*#__PURE__*/_jsx(AssignToUserHeader, {
        shouldShowTooltip: shouldShowTooltip,
        workspaceId: workspaceId
      });
    case SEARCH_MORE_OPTION:
      return /*#__PURE__*/_jsx(SearchMoreLabel, {});
    default:
      return renderAssignee({
        option,
        currentUserId,
        currentAssigneeId,
        routingSource,
        showCapacityStatus
      });
  }
}, [currentAssigneeId, handleUnassign, canRouteToAvailable, routingSource, shouldShowTooltip, workspaceId, currentUserId, showCapacityStatus]);